import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InfoRow from 'components/common/InfoRow';
import SubtleBadge from 'components/common/SubtleBadge';

import { TIME_OPTION } from 'constants/time';

const ShelfViewMode = ({ shelf }) => {
  return (
    <Row>
      <Col md={4}>
        <InfoRow label="Code" value={shelf?.code} />

        <InfoRow label="Name" value={shelf?.name} />

        <InfoRow label="Warehouse" value={shelf?.warehouse?.name} />
      </Col>

      <Col md={4}>
        <InfoRow
          label="Status"
          value={
            <SubtleBadge bg={shelf?.is_active ? 'success' : 'secondary'}>
              {shelf?.is_active ? 'Active' : 'Inactive'}
            </SubtleBadge>
          }
        />

        <InfoRow label="Description" value={shelf?.description} />

        <InfoRow
          label="Created Date"
          value={new Date(shelf?.created).toLocaleString('en-IN', TIME_OPTION)}
        />
      </Col>

      <Col md={4}>
        <InfoRow
          label="Location Image"
          value={
            shelf?.location_image ? (
              <img
                src={shelf.location_image}
                alt="Location"
                className="img-thumbnail"
                style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <div
                className="d-flex align-items-center justify-content-center border rounded bg-light"
                style={{ width: '100px', height: '100px' }}
              >
                <div className="text-center">
                  <FontAwesomeIcon icon="image" className="fs-8" />
                  <p className="mb-0 fs-9">No Image</p>
                </div>
              </div>
            )
          }
        />
      </Col>
    </Row>
  );
};

export default ShelfViewMode;
